import { render } from "./offresCommerciales.vue?vue&type=template&id=06be8490"
import script from "./offresCommerciales.vue?vue&type=script&lang=ts"
export * from "./offresCommerciales.vue?vue&type=script&lang=ts"
script.render = render

export default script